import { ModelBase, Property } from '@skylab-shared/core';
import { OrderPaymentProvider } from './common/order-payment-kind';

export class OrderPaymentModel extends ModelBase {
	@Property({ identifiable: true })
	public id: number;

	@Property()
	public externalId: string;

	@Property()
	public finishedAt: Date;

	@Property()
	public provider: OrderPaymentProvider;

	@Property()
	public currencyExternalId: string;

	@Property()
	public amount: number;
}
